import React, { useState } from "react";
import * as utils from "../utils";
import { login } from "./services";

import "./style.css";

export default function LoginSBDValidation() {
  const [cpfMask, setCpfMask] = useState("");
  const [urlRedirect, seturlRedirect] = useState("");

  const [urlBase, setUrlBase] = useState("");
  const [neo, setNeo] = useState("");
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");

  const handleSend = async (e) => {
    const inputPassword = document.querySelector("#input_password");
    const button = document.querySelector("#button_send");

    e.preventDefault();
    const cpf = cpfMask.trim();
    const password = inputPassword.value;

    if (!utils.isCpf(cpf) && !utils.IsEmail(cpf)) return noCpf();

    if (utils.IsSomething(password)) {
      button.setAttribute("disabled", "true");
      const auth = {
        cpf: cpf,
        password: password,
      };
      const data = await login(auth);

      if (data.url) {
        console.log(data.url);
        return success(data);
      }
      // caso erro
      noSuccess(data.message);
      button.removeAttribute("disabled");
    } else {
      noPass();
    }
  };
  const success = async (data) => {
    const { url } = data;
    redirectFunc(url);
  };
  const redirectFunc = async (urlRedirect) => {
    await setUrlBase(urlRedirect.split("?")[0]);
    const params = urlRedirect.split("?")[1].split("&");
    await setNeo(params[0].split("=")[1]);
    await setUser(params[1].split("=")[1]);
    await setPass(params[2].split("=")[1]);

    const formPost = document.querySelector("#testForm");

    formPost.submit();
  };
  const noCpf = () => {
    clearForm();
    const popUp = document.querySelector("#input__defalt_popup");
    const popUpText = document.querySelector("#input__defalt_popup_text");

    popUpText.innerHTML = "<p>Adicione um CPF ou Email válido.</p>";
    popUp.classList.remove("hideDiv");
  };
  const noPass = () => {
    clearForm();
    const popUp = document.querySelector("#input__defalt_popup");
    const popUpText = document.querySelector("#input__defalt_popup_text");

    popUpText.innerHTML = "<p>O campo senha deve ser preenchido.</p>";
    popUp.classList.remove("hideDiv");
  };
  const noSuccess = (data) => {
    clearForm();

    const popUp = document.querySelector("#input__defalt_popup");
    const popUpText = document.querySelector("#input__defalt_popup_text");

    popUpText.innerHTML = `<p>${data}</p>`;
    popUp.classList.remove("hideDiv");
  };
  const closePopUp = () => {
    const popUp = document.querySelector("#input__defalt_popup");
    popUp.classList.add("hideDiv");
    showForm();
  };
  const clearForm = () => {
    const inputCpf = document.querySelector("#input_cpf");
    const inputPassword = document.querySelector("#input_password");
    const button = document.querySelector("#button_send");
    inputCpf.classList.add("hideDiv");
    inputPassword.classList.add("hideDiv");
    button.classList.add("hideDiv");
  };
  const showForm = () => {
    const inputCpf = document.querySelector("#input_cpf");
    const inputPassword = document.querySelector("#input_password");
    const button = document.querySelector("#button_send");
    inputCpf.classList.remove("hideDiv");
    inputPassword.classList.remove("hideDiv");
    button.classList.remove("hideDiv");
  };

  return (
    <div className="container__default">
      <form
        onSubmit={handleSend}
        id="retrive_password_form"
        className="input__defalt"
      >
        <div className="input__defalt_popup hideDiv" id="input__defalt_popup">
          <p id="input__defalt_popup_text"></p>
          <button
            onClick={closePopUp}
            className="input__defalt input__defalt_popup_button"
            type="button"
          >
            ok
          </button>
        </div>
        <input
          className="input__defalt"
          id="input_cpf"
          value={cpfMask}
          onChange={(e) => setCpfMask(e.target.value)}
          placeholder="Email ou CPF"
        />
        <input
          className="input__defalt"
          type="password"
          id="input_password"
          placeholder="Senha"
        />
        <div className="btnContainer">
          <a
            className="link"
            onClick={() => (window.location.href = `${__dirname}SBDpassword`)}
          >
            Esqueceu a senha?
          </a>
          <button className="input__defalt" id="button_send" type="submit">
            Acessar
          </button>
        </div>
      </form>
      <form id="testForm" method="post" action={urlBase} target="_top">
        <input type="hidden" name="neo" value={neo} />
        <input type="hidden" name="user" value={user} />
        <input type="hidden" name="password" value={pass} />
      </form>
    </div>
  );
}
